import React from "react";
import { Link } from "react-router-dom";
import { BRAND } from "@/lib/brand";

const COLS = [
  {
    title: "Store",
    links: [
      { label: "All products", href: "/#store" },
      { label: "Fight Studio", href: "/#features" },
      { label: "Karate GI’s", href: "/#karate-gis" },
      { label: "Install", href: "/#install" },
    ],
  },
  {
    title: "Support",
    links: [
      { label: "Changelog", to: "/changelog" },
      { label: "Discord", href: BRAND.discord, ext: true },
      { label: "FAQ", href: "/#faq" },
    ],
  },
];

export const Footer = () => (
  <footer className="relative overflow-hidden border-t border-white/8 bg-[#08080a]">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="grid gap-12 py-16 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <img src={BRAND.lockup} alt="Orvyn FiveM Scripts" className="h-16 w-auto" />
          <p className="mt-6 max-w-sm text-[13px] leading-relaxed text-white/35">
            Cinematic tooling for FiveM roleplay servers. Built standalone, shipped with support.
          </p>
        </div>

        {COLS.map((c) => (
          <div key={c.title} className="lg:col-span-2">
            <div className="label">{c.title}</div>
            <ul className="mt-5 space-y-3">
              {c.links.map((l) => (
                <li key={l.label}>
                  {l.to ? (
                    <Link
                      to={l.to}
                      data-testid={`footer-link-${l.label.toLowerCase()}`}
                      className="text-[13px] text-white/50 transition-colors duration-300 hover:text-white"
                    >
                      {l.label}
                    </Link>
                  ) : (
                    <a
                      href={l.href}
                      {...(l.ext ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                      data-testid={`footer-link-${l.label.toLowerCase()}`}
                      className="text-[13px] text-white/50 transition-colors duration-300 hover:text-white"
                    >
                      {l.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}

        <div className="lg:col-span-3">
          <div className="label">Latest release</div>
          <Link
            to="/changelog"
            className="mt-5 block font-display text-2xl font-bold uppercase tracking-tight text-white transition-colors duration-300 hover:text-[hsl(var(--orv-blue))]"
          >
            Fight Studio {BRAND.version}
          </Link>
          <div className="mt-2 font-mono text-[11px] tracking-[0.12em] text-white/30">
            Standalone · Documented
          </div>
        </div>
      </div>

      <div className="overflow-hidden border-t border-white/8 pt-10 pb-8">
        <div className="select-none whitespace-nowrap text-center font-display text-[clamp(3rem,14vw,12rem)] font-extrabold uppercase leading-none tracking-[0.02em] text-white/[0.045]">
          Orvyn
        </div>
        <div className="mt-6 flex flex-wrap items-center justify-between gap-4 font-mono text-[10px] uppercase tracking-[0.16em] text-white/25">
          <span>© {new Date().getFullYear()} Orvyn FiveM Scripts</span>
          <span>Not affiliated with Rockstar Games or Cfx.re</span>
        </div>
      </div>
    </div>
  </footer>
);
